import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ApiSdkService } from '../services/api-sdk.service';

/** The single account allowed to see the CEO pages — same rule the support chat uses. */
export const CEO_EMAIL = 'speedparadigm@gmail.com';

/**
 * Keeps the CEO pages out of every other account's hands.
 *
 * This is convenience only — the real enforcement is server-side (account-backend gates
 * /api/v1/ceo-dashboard on the JWT's email), so a user who hand-navigates to /ceo gets a
 * page with no data rather than a data leak. The guard just avoids showing them an empty shell.
 */
@Injectable({
  providedIn: 'root'
})
export class CeoGuard implements CanActivate {

  constructor(
    private router: Router,
    private apiSdkService: ApiSdkService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const token = localStorage.getItem('token');
    if (!token) {
      return this.router.createUrlTree(['/login']);
    }

    try {
      const result = await this.apiSdkService.getFullUserData(true);
      const email = result?.success?.data?.email;

      if (email !== CEO_EMAIL) {
        return this.router.createUrlTree(['/account']);
      }
      return true;
    } catch (error) {
      console.error('Error checking CEO access:', error);
      return this.router.createUrlTree(['/account']);
    }
  }
}
